import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang'
import {getToken,getUserInfo} from './utils/auth'
 
import ElementUI from 'element-ui';
import notData from './components/notData'
import tableNull from './components/tableNull'
import eventRequest from './common/utils/eventRequest.js'
// import  eventRequest from './utils/eventRequest1.js' 
// import './plugins/element.js'
import './common/style/normalize.css'
import './common/style/common.scss'

import 'element-ui/lib/theme-chalk/index.css';
 
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

import * as echarts from 'echarts/core';
import { TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';

echarts.use(
	[TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, LineChart, CanvasRenderer, PieChart]
)

Vue.prototype.$echarts = echarts
Vue.prototype.$eventRequest = eventRequest

// Vue.use(notData)
Vue.component('NoData',notData)
Vue.component('TableNull',tableNull)
Vue.config.productionTip = false

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  Vue.prototype.$pc = false
  //hostConfig.vconsole && new VConsole()
} else {
  Vue.prototype.$pc = true
  let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
  winWidth = winWidth < 1366 ? 1366 : winWidth
  let oHtml = document.getElementsByTagName('html')[0]
  oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  window.addEventListener('resize', function () {
    let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
    winWidth = winWidth < 1366 ? 1366 : winWidth
    let oHtml = document.getElementsByTagName('html')[0]
    oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  })
}

router.beforeEach((to, from, next) => {
  Vue.prototype.$message.closeAll()
  const CancelToken = Vue.axios.CancelToken
  store.state.source.cancel && store.state.source.cancel()
  store.commit('setSource', CancelToken.source())
  if(to.path == '/login' || to.path == '/resetPwd' || to.path == '/register' || to.path == '/signIn'){
	  if(getToken()){
		  next(from.path)
	  }else{
		  next()
	  }
  }else{
	  if(!getToken()){
		  next('/signIn')
	  }else{
		  next()
	  }
  }
})


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


router.beforeResolve((to, from, next) => {
	let back = false
	if(to.meta.isBack){
		back = to.meta.isBack
	}
	store.commit('setBackStatus',back)
	store.commit('setPageTitle',to.meta.title)
	next();
  /* 必须调用 `next` */
})

// 定义一个过滤器 处理时间
Vue.filter('dateFormatYM', function (originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  // 月份从0开始,使她变成字符串,不足两位时,前面补个0.
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${y}-${m}`
})
